import {Component, ViewEncapsulation, AfterViewInit, Inject, PipeTransform} from "@angular/core";
import {FixrAPIApi} from "../../shared/sdk/services/custom/FixrAPI";
import {ActivatedRoute, Router} from "@angular/router";
import {LoopBackConfig} from "../../shared/sdk/lb.config";
import {BASE_URL, API_VERSION} from "../../shared/base.url";
import {TransferState} from "../../../modules/transfer-state/transfer-state";
import {FormBuilder, FormControl, FormGroup} from "@angular/forms";
import {BehaviorSubject} from "rxjs";
import {JobApi} from "../../shared/sdk/services/custom/Job";

declare var window: any;
declare var classie: any;
declare var FForm: any;
declare var ga: any;

@Component({
  templateUrl: './questionnaire-form.component.html',
  styleUrls: [ './questionnaire-form.component.scss'],
  selector: 'questionnaireFormComponent',
  encapsulation: ViewEncapsulation.None,
})

export class QuestionnaireFormComponent implements AfterViewInit {

  public jobQuestionnaireForm: FormGroup;
  public questions: any;
  public verticalType: number;
  protected jobQuestionnaireSubject: BehaviorSubject<any> = new BehaviorSubject(false);
  protected taskId: string;
  protected analyticsClientId: string;

  protected pagePostedFrom:string = null;

  constructor(@Inject('isBrowser') protected isBrowser: boolean,
              protected route: ActivatedRoute,
              protected cache: TransferState,
              @Inject(FormBuilder) protected formBuilder: FormBuilder,
              protected router: Router,
              protected fixrAPIApi: FixrAPIApi,
              protected jobApi: JobApi) {


    this.jobQuestionnaireForm = this.formBuilder.group({
      jobDescription: new FormControl(),
      zipcode: new FormControl(),
      street: new FormControl(),
      firstName: new FormControl(),
      lastName: new FormControl(),
      email: new FormControl(),
      phoneNumber: new FormControl()
    });

    LoopBackConfig.setBaseURL(BASE_URL);
    LoopBackConfig.setApiVersion(API_VERSION);

    this.route.url.subscribe((parts: any) => {
      if(parts[0].path.indexOf('remodel') === 0) {
        this.verticalType = VerticalType.Remodeling;
      }
      else if(parts[0].path.indexOf('insurance') === 0){
        this.verticalType = VerticalType.Insurance;
      }
      this.taskId = parts[1].path;
      this.loadForm(this.taskId);
    });

  }

  ngAfterViewInit() {
    if(this.isBrowser) {

      ga((tracker) => {
        this.analyticsClientId = tracker.get('clientId');
      });

      this.jobQuestionnaireSubject.subscribe(initialized => {
        if(initialized == true) {
          this.initializeForm();
        }
      });
    }
  }

  protected initializeForm() {
    window.FForm = FForm;
    let formWrap = document.getElementById('fs-form-wrap');
    new window.FForm(formWrap, {
      ctrlNavDots : this.questions.length + 5 > 12?false:true,
      onReview: () => {
        $('#jobQuestionnaire').css('display', 'none');
        this.submitLead();
      }
    });

  }

  protected loadForm(taskIds) {

    var questionnaireObject = this.cache.get(taskIds);
    if (questionnaireObject != null) {
      this.renderForm(questionnaireObject);
    }
    else {
      this.fixrAPIApi.getJobQuestionnaires(taskIds).subscribe(questionnaire => {
        let questionnaireObject = JSON.parse(questionnaire[0]);
        this.cache.set(taskIds, questionnaireObject);
        this.renderForm(questionnaireObject);
      });
    }

  }

  protected submitLead() {

    let job = {
      "pagePostedFromValue": this.pagePostedFrom,
      "analyticsClientId": this.analyticsClientId,
      "taskId": this.taskId,
      "verticalType": this.verticalType,
      "tcpaConsent": true,
      "tcpaCopy": "By clicking 'Get Quotes Now' you are giving your consent to be contacted at the phone number you inputted (including wireless number if provided). Contacting you is for the purpose of confirming and scheduling your home improvement project request and multiple contractor bids. You understand that automated phone technology, by voice or text messages, may be used to reach you. Please note that providing consent does not obligate you to purchase or use any product or service.",
      "specificQuestions": {},
    };

    for(let input in this.jobQuestionnaireForm.value) {
      if(input.match(/q(\d+)?\_/g) != null) {
        if(this.jobQuestionnaireForm.value[input] != null) {
          if(this.jobQuestionnaireForm.value[input].constructor === Object) {
            let answers = [];
            for(let answer in this.jobQuestionnaireForm.value[input]) {
              if(this.jobQuestionnaireForm.value[input][answer] != null) {
                answers.push(answer);
              }
            }
            if(answers.length > 0) {
              job["specificQuestions"][input] = answers;
            }
          }
          else {
            job["specificQuestions"][input] = [ this.jobQuestionnaireForm.value[input] ];
          }
        }
      }
      else {
        job[input] = this.jobQuestionnaireForm.value[input];
      }
    }

    this.jobApi.create(job).subscribe(job => {
      if(this.verticalType == VerticalType.Remodeling) {
        this.router.navigateByUrl('/remodeling-form-success');
      }
      else {
        this.router.navigateByUrl('/insurance-form-success');
      }
    });

  }

  protected renderForm(questionnaire) {

    for(let questionnaireName in questionnaire) {

      //populate specific job questionnaire questions form controls:
      questionnaire[questionnaireName].questions.forEach(question => {
        if(question.inputType == 1) {
          let formGroup = {};
          question.answers.forEach(answer => {
            formGroup[answer.id.trim()] = new FormControl();
          });
          this.jobQuestionnaireForm.addControl(question.id.trim(), this.formBuilder.group(formGroup));
        }
        else {
          this.jobQuestionnaireForm.addControl(question.id.trim(), new FormControl());
        }

      });

      //set questions:
      this.questions = questionnaire[questionnaireName].questions;
      setTimeout(() => {
        this.jobQuestionnaireSubject.next(true);
      });
      return;
    }

  }

  public openTermsOfUse() {
    window.open('/terms-of-use.html', '_blank');
  }

  public openTcpa() {
    alert('By clicking "Continue" you are giving your consent to be contacted at the phone number you inputted (including wireless number if provided). Contacting you is for the purpose of confirming and scheduling your home improvement project request and multiple contractor bids. You understand that automated phone technology, by voice or text messages, may be used to reach you. Please note that providing consent does not obligate you to purchase or use any product or service.');
  }

}

export enum VerticalType {
  Remodeling = 1,
  Insurance = 2
}



// WEBPACK FOOTER //
// ./src/app/lead-form/questionnaire-form/questionnaire-form.component.ts